import {
    OnboardingHeaderDescriptionStyled,
    OnboardingWelcomePageButtonContainerStyled,
    OnboardingWelcomePageContainerStyled,
    OnboardingWelcomePageContentStyled,
    OnboardingWelcomePageStyled
} from "./styled/OnboardingWelcomePageStyled";
import { BinIcon } from "../../components/icon/Icon";
import { Button } from "react-bootstrap";
import appHistory from "../../app/appHistory";
import { RouterPaths } from "../../app/appConstants";
import { useCallback } from "react";
import { OnboardingIconContainerStyled } from "./styled/OnboardingStyled";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";
import { generatePath } from "react-router";
import { isClientIOS } from "../../components/ClientInfo/ClientInfo";
import { Redirect } from "react-router-dom";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

export const OnboardingWelcomePage = () => {
    const {getLangPath} = useLangContext();
    const {pushGtmEvent} = useGTMEvent({module: 'OnboardingWelcomePage'});
    const handleClickStartTutorial = useCallback(() => {
        pushGtmEvent({event: 'onboarding_click', button: 'StartOnboarding'})
        appHistory.push(generatePath(RouterPaths.onboardingTutorial, {attempt: 'initial'}));
    }, [pushGtmEvent]);

    const handleClickSkipTutorial = useCallback(() => {
        pushGtmEvent({event: 'onboarding_click', button: 'Later'})
        appHistory.push(RouterPaths.mobileDepositBonus);
    }, [pushGtmEvent]);

    if (isClientIOS) {
        return <Redirect to={RouterPaths.mobileDepositBonus}/>
    }

    return (
            <OnboardingWelcomePageStyled>
                <OnboardingWelcomePageContainerStyled>
                    <div className="d-flex justify-content-center">
                        <OnboardingIconContainerStyled>
                            <BinIcon name="IcGraduationCap"/>
                        </OnboardingIconContainerStyled>
                    </div>
                    <h1 className="text-center mt-3 mb-0">{getLangPath('welcome.title')}</h1>
                    <OnboardingHeaderDescriptionStyled>
                        {getLangPath('onboarding.first_steps')}
                    </OnboardingHeaderDescriptionStyled>
                    <OnboardingWelcomePageContentStyled>
                        <h3 dangerouslySetInnerHTML={{__html: getLangPath('onboarding.demo_account')}}/>
                        <p className="mb-0">{getLangPath('onboarding.more_lesson')}</p>
                    </OnboardingWelcomePageContentStyled>
                </OnboardingWelcomePageContainerStyled>

                <OnboardingWelcomePageButtonContainerStyled>
                    <Button
                            size="lg"
                            variant="primary"
                            onClick={handleClickStartTutorial}
                    >
                        {getLangPath('onboarding.go_button')}
                    </Button>
                    <Button
                            className="mt-3"
                            size="lg"
                            variant="outline-info"
                            onClick={handleClickSkipTutorial}
                    >
                        {getLangPath('onboarding.later_button')}
                    </Button>
                </OnboardingWelcomePageButtonContainerStyled>
            </OnboardingWelcomePageStyled>
    )
}
